export default __webpack_public_path__ + "static/media/Belt of the Faceless Chaos.aef136e5.jpg";